<template>
  <li class="relative border-b-2 border-gray-100 pb-2">
    <div data-testid="news-section-content">
      <button
        class="float-right appearance-none p-0 mb-2 bg-transparent hidden md_block"
        :data-testid="`news-section-content-share-${post.id}`"
        @click="handleShareClick(post)"
      >
        <div class="flex justify-evenly items-center">
          <ArrowUpTrayIcon class="w-5 mr-2" /><span class="font-medium text-sm">Share</span>
        </div>
      </button>
      <a class="block text-gray-950 mb-2 hover_text-gray-950 md_mb-0" :data-testid="`news-section-content-link-${post.id}`" :href="uri">
        <article>
          <div
            v-if="post.deck"
            class="press-deck-image mt-1 mb-4 md_float-right clear-right md_ml-8 relative"
            data-testid="news-section-content-image"
          >
            <img
              v-if="post.deck.deck_image"
              class="absolute inset-0 object-cover w-full h-full rounded-lg border border-solid border-gray-300"
              :src="post.deck.deck_image"
              :alt="post.title"
            /><button
              class="absolute top-2 right-2 rounded-full appearance-none bg-transparent md_hidden bg-black bg-opacity-30 px-1 pb-1"
              :data-testid="`news-section-content-share-${post.id}`"
              @click="handleShareClick(post)"
            >
              <ArrowUpTrayIcon class="text-white w-4" />
            </button>
            <div class="flex justify-start absolute bottom-2 left-2 gap-2">
              <CompaniesIconsThreeDPill v-if="post.deck.tags.indexOf('3D') > -1" />
              <CompaniesIconsThreeSixtyPill v-if="post.deck.tags.indexOf('360') > -1" />
            </div>
          </div>
          <div class="press-deck-content">
            <h3 class="text-base leading-normal font-semibold lg_w-auto lg_text-lg _w-4/5 mb-2">{{ post.title }}</h3>
            <p class="text-sm leading-normal font-normal mb-4 lg_text-base">{{ post.content ? formatPostContent(post.content) : '' }}</p>
            <p class="text-xs leading-none font-medium text-gray-600 lg_text-sm">
              {{ formatDateFull(post.date) }} {{ post.author ? ' | ' + post.author : '' }}
            </p>
          </div>
        </article>
      </a>
    </div>
    <div class="clear-both h-px">&nbsp;</div>
  </li>
</template>

<script lang="ts" setup>
import { decode } from 'html-entities'
import { ArrowUpTrayIcon } from '@heroicons/vue/24/outline'
import type { NewsfeedPost } from '@/entities/newsfeedPost'
import type { DeepReadonly, PropType } from 'vue'
import { formatDateFull } from '@/lib/datetime-format-utils'
import CompaniesIconsThreeDPill from '@/components/companies/icons/ThreeDPill.svg'
import CompaniesIconsThreeSixtyPill from '@/components/companies/icons/ThreeSixtyPill.svg'

const props = defineProps({
  post: {
    type: Object as PropType<DeepReadonly<NewsfeedPost>>,
    required: true,
  },
})

const emit = defineEmits(['on-item-clicked', 'on-share-clicked'])

const uri = computed(() => `${window.location.origin}/press-releases/${props.post.url_slug}`)

function formatPostContent(content: string) {
  content = content.replace(/(<([^>]+)>)/gi, '')
  content = content.slice(0, 350)
  content = content + '&hellip;'
  return decode(content)
}

function handleShareClick(post: DeepReadonly<NewsfeedPost>) {
  emit('on-share-clicked', post)
}
</script>

<style lang="stylus" scoped>
.press-deck
  &-content
    max-width 88%

  &-image
    width 100%
    aspect-ratio 16/9

@screen md
  .press-deck-image
    width 16rem
    height 9rem

li:last-of-type
  border 0
</style>
